<template>
	<div class="layout-topbar">
		<div class="topbar-left">
			<router-link to="/" class="layout-topbar-logo">
				<img alt="Logo" src="../src/assets/img/logo_small.svg" width="65" height="auto" />
			</router-link>
			<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
				<i class="pi pi-bars"></i>
			</button>
		</div>

		<button class="p-link layout-topbar-menu-button layout-topbar-button" v-styleclass="{
			selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein',
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true
		}">
			<i class="pi pi-ellipsis-v"></i>
		</button>

		<ul class="layout-topbar-menu hidden lg:flex origin-top">


			<li v-if="currentUser" class="topbar-item user-info">
				<div class="user-avatar">
					<i class="pi pi-user"></i>
				</div>
				<div class="user-details">
					<span class="user-name">{{ currentUser.name || 'Utente' }}</span>
					<small class="user-email">{{ currentUser.email }}</small>
				</div>
			</li>
<!-- 
			<li v-if="currentUser && currentUser.role == roles.admin.role" class="topbar-item">
				<button class="p-link topbar-action-button" @click="$refs.menu1.toggle($event)">
					<i class="pi pi-cog"></i>
					<Menu ref="menu1" :popup="true" :model="items"></Menu>
					<span>Impostazioni</span>
				</button>
			</li>

			<li class="topbar-item">
				<button @click="showConfirmDialog" class="p-link topbar-action-button logout-button">
					<i class="pi pi-sign-out"></i>
					<span>Logout</span>
				</button>
			</li> -->
		</ul>
	</div>
	<ConfirmDialog>
		<template #message="slotProps">
			<div class="confirm-dialog-custom">
				<i :class="slotProps.message.icon" class="logout-icon"></i>
				<p>{{ slotProps.message.message }}</p>
			</div>
		</template>
		<template #footer="slotProps">
			<div class="confirm-dialog-footer">
				<Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="slotProps.reject" />
				<Button label="Conferma" icon="pi pi-check" class="p-button-danger" @click="slotProps.accept" />
			</div>
		</template>
	</ConfirmDialog>
</template>

<script>
import { ref, getCurrentInstance, onMounted } from 'vue'
import { useStore } from 'vuex'
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { computed } from "vue";
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import roles from '@/config/roles'

export default ({
	emits: ["menu-toggle", "topbar-menu-toggle"],
	setup() {
		const self = getCurrentInstance();
		const eventBus = self.appContext.config.globalProperties.$eventBus
		const service = new Service(eventBus)
		const appState = self.appContext.config.globalProperties.$appState
		const store = useStore()
		const toast = useToast();
		const confirm = useConfirm();
		const currentUser = ref(store.state.auth.user)
		const items = ref([
			{
				label: 'Impostazioni App',
				icon: 'pi pi-cog',
				// to: '/settings'			
			},
			{
				label: 'Gestione Utenti',
				icon: 'pi pi-users',
				// to: '/users'
			},
		])

		onMounted(() => {
			getStatusSii()
		})

		const getStatusSii = async () => {
			if (process.env.NODE_ENV === 'production') {
				store.state.statusSII = null
				store.state.statusSII = true
				if (!store.state.statusSII) {
					toast.add({ severity: 'warn', summary: 'Attenzione:', detail: 'Sembra che il portale SII non sia raggiungibile' });
				}
			}
		}

		setInterval(() => {
			getStatusSii()
		}, 600000)

		const showConfirmDialog = () => {
			confirm.require({
				message: 'Sei sicuro di voler uscire dal sistema?',
				header: 'Conferma Logout',
				acceptIcon: 'pi pi-check',
				rejectIcon: 'pi pi-times',
				acceptClass: 'p-button-danger',
				accept: () => {
					handleLogout()
				},
				reject: () => {
				}
			});

			setTimeout(() => {
				const dialog = document.querySelector('.p-confirm-dialog');
				if (dialog) dialog.classList.add('custom-logout');
			}, 10);
		}

		const handleLogout = () => {
			store.dispatch("auth/logout").then(
				() => {
					toast.add({
						severity: 'success',
						summary: 'Logout effettuato',
						detail: 'Disconnessione avvenuta con successo',
						life: 3000
					});

					setTimeout(() => {
						window.location.href = '/login';
					}, 1000);
				},
				(error) => {
					console.log(error)
					toast.add({
						severity: 'error',
						summary: 'Errore',
						detail: 'Si è verificato un errore durante il logout',
						life: 3000
					});
				}
			);
		}

		const onMenuToggle = (event) => {
			eventBus.emit('menu-toggle', event);
		}

		const onTopbarMenuToggle = (event) => {
			eventBus.emit('topbar-menu-toggle', event);
		}

		const darkTheme = computed(() => {
			return appState.theme.startsWith('saga');
		})

		return {
			items,
			onMenuToggle,
			onTopbarMenuToggle,
			darkTheme,
			currentUser,
			store,
			roles,
			showConfirmDialog
		}
	}
})
</script>

<style lang="scss">
/* Layout Topbar */
.layout-topbar {
	position: fixed;
	height: 4rem;
	z-index: 997;
	left: 0;
	top: 0;
	width: 100%;
	padding: 0 2rem;
	background-color: #215159;
	color: white;
	transition: left 0.3s ease;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	
	.topbar-left {
		display: flex;
		align-items: center;
	}
	
	.layout-topbar-logo {
		display: flex;
		align-items: center;
		color: white;
		font-size: 1.4rem;
		font-weight: 600;
		margin-right: 1rem;
		
		img {
			height: 2.5rem;
		}
		
		&:focus {
			outline: none;
		}
	}
	
	.layout-topbar-button {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		color: white;
		border-radius: 4px;
		width: 2.5rem;
		height: 2.5rem;
		cursor: pointer;
		transition: all 0.2s;
		
		&:hover {
			background-color: rgba(255, 255, 255, 0.1);
		}
		
		i {
			font-size: 1.2rem;
		}
	}
	
	.layout-topbar-menu-button {
		display: none;
	}
	
	.layout-topbar-menu {
		margin: 0;
		padding: 0;
		list-style: none;
		display: flex;
		align-items: center;
		height: 100%;
		
		.topbar-item {
			height: 4rem;
			display: flex;
			align-items: center;
			padding: 0 0.75rem;
			position: relative;
			
			&:not(:last-child):after {
				content: '';
				position: absolute;
				width: 1px;
				height: 24px;
				background-color: rgba(255, 255, 255, 0.1);
				right: 0;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		
		.topbar-action-button {
			display: flex;
			align-items: center;
			background-color: transparent;
			border: none;
			padding: 0.5rem 0.75rem;
			color: white;
			font-size: 0.9rem;
			border-radius: 4px;
			cursor: pointer;
			transition: all 0.2s;
			
			i {
				font-size: 1.1rem;
				margin-right: 0.5rem;
			}
			
			&:hover {
				background-color: rgba(255, 255, 255, 0.1);
			}
		}
		
		.user-info {
			display: flex;
			align-items: center;
			
			.user-avatar {
				width: 2.5rem;
				height: 2.5rem;
				border-radius: 50%;
				background-color: rgba(255, 255, 255, 0.1);
				display: flex;
				justify-content: center;
				align-items: center;
				margin-right: 0.75rem;
				
				i {
					font-size: 1rem;
					color: white;
				}
			}
			
			.user-details {
				display: flex;
				flex-direction: column;
				
				.user-name {
					font-weight: 500;
					font-size: 0.875rem;
					line-height: 1.2;
				}
				
				.user-email {
					font-size: 0.75rem;
					opacity: 0.8;
					line-height: 1.2;
				}
			}
		}
		
		.logout-button {
			color: white;
			background: linear-gradient(135deg, rgba(244, 67, 54, 0.2), rgba(211, 47, 47, 0.3));
			border: 1px solid rgba(244, 67, 54, 0.4);
			border-radius: 8px;
			position: relative;
			overflow: hidden;
			transition: all 0.3s ease;
			
			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: -100%;
				width: 100%;
				height: 100%;
				background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
				transition: left 0.6s;
			}
			
			&:hover {
				background: linear-gradient(135deg, rgba(244, 67, 54, 0.3), rgba(211, 47, 47, 0.4));
				border-color: rgba(244, 67, 54, 0.6);
				transform: translateY(-2px);
				box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3);
				
				&::before {
					left: 100%;
				}
				
				i {
					animation: logout-pulse 0.6s ease-in-out;
				}
			}
			
			i {
				color: #ff6b6b;
				transition: all 0.3s ease;
			}
		}
	}
}

/* Dialog Logout Personalizzato */
.p-confirm-dialog.custom-logout {
	border-radius: 12px !important;
	overflow: hidden !important;
	box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
	animation: dialog-appear 0.3s ease-out !important;
	border: none !important;
}

.p-confirm-dialog.custom-logout .p-dialog-header {
	background: linear-gradient(135deg, #215159, #2c6b73) !important;
	color: white !important;
	text-align: center !important;
	padding: 2rem !important;
	position: relative !important;
	border: none !important;
}

.p-confirm-dialog.custom-logout .p-dialog-header::before {
	content: '' !important;
	position: absolute !important;
	top: 0 !important;
	left: 50% !important;
	transform: translateX(-50%) !important;
	width: 80px !important;
	height: 3px !important;
	background: rgb(5, 181, 166) !important;
	border-radius: 0 0 3px 3px !important;
}

.p-confirm-dialog.custom-logout .p-dialog-title {
	font-size: 1.4rem !important;
	font-weight: 600 !important;
	margin: 0 !important;
	color: white !important;
	letter-spacing: 0.5px !important;
}

.p-confirm-dialog.custom-logout .p-dialog-header-icon {
	color: rgba(255, 255, 255, 0.8) !important;
	transition: all 0.2s ease !important;
	border-radius: 6px !important;
}

.p-confirm-dialog.custom-logout .p-dialog-header-icon:hover {
	color: white !important;
	background-color: rgba(5, 181, 166, 0.2) !important;
}

.p-confirm-dialog.custom-logout .p-dialog-content {
	padding: 3rem 2rem !important;
	background: white !important;
	text-align: center !important;
	border: none !important;
}

.p-confirm-dialog.custom-logout .confirm-dialog-custom {
	display: flex !important;
	flex-direction: column !important;
	align-items: center !important;
	text-align: center !important;
}

.p-confirm-dialog.custom-logout .logout-icon {
	display: none !important;
}

.p-confirm-dialog.custom-logout .confirm-dialog-custom p {
	font-size: 1.1rem !important;
	color: #333 !important;
	font-weight: 500 !important;
	margin: 0 !important;
	line-height: 1.5 !important;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
}

.p-confirm-dialog.custom-logout .p-dialog-footer {
	background: #f8f9fa !important;
	padding: 1.5rem 2rem !important;
	border-top: 1px solid #e9ecef !important;
	border: none !important;
}

.p-confirm-dialog.custom-logout .confirm-dialog-footer {
	display: flex !important;
	justify-content: center !important;
	gap: 1rem !important;
}

.p-confirm-dialog.custom-logout .p-button {
	font-weight: 500 !important;
	padding: 0.8rem 2rem !important;
	border-radius: 8px !important;
	font-size: 0.9rem !important;
	transition: all 0.2s ease !important;
	border: 2px solid transparent !important;
	min-width: 120px !important;
}

.p-confirm-dialog.custom-logout .p-button-danger {
	background: rgb(5, 181, 166) !important;
	border-color: rgb(5, 181, 166) !important;
	color: white !important;
}

.p-confirm-dialog.custom-logout .p-button-danger:hover {
	background: rgb(4, 160, 147) !important;
	border-color: rgb(4, 160, 147) !important;
	transform: translateY(-1px) !important;
	box-shadow: 0 4px 12px rgba(5, 181, 166, 0.3) !important;
}

.p-confirm-dialog.custom-logout .p-button-text {
	color: #6c757d !important;
	border: 2px solid #dee2e6 !important;
	background: white !important;
}

.p-confirm-dialog.custom-logout .p-button-text:hover {
	background: #f8f9fa !important;
	border-color: #adb5bd !important;
	color: #495057 !important;
	transform: translateY(-1px) !important;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Overlay Dialog */
:deep(.p-dialog-mask) {
	background-color: rgba(0, 0, 0, 0.6) !important;
	backdrop-filter: blur(8px) !important;
}

/* Responsive Design */
@media (max-width: 991px) {
	.layout-topbar {
		.layout-topbar-menu-button {
			display: inline-flex;
		}
		
		.layout-topbar-menu {
			position: absolute;
			flex-direction: column;
			background-color: #215159;
			box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
			border-radius: 6px;
			padding: 1rem;
			right: 2rem;
			top: 4rem;
			min-width: 15rem;
			z-index: 999;
			
			.topbar-item {
				height: auto;
				width: 100%;
				padding: 0.5rem 0;
				
				&:after {
					display: none;
				}
			}
			
			.topbar-action-button,
			.logout-button {
				width: 100%;
				justify-content: flex-start;
				padding: 0.75rem;
			}
			
			.user-info {
				padding: 0.75rem;
				border-radius: 6px;
				margin-bottom: 0.5rem;
				background-color: rgba(255, 255, 255, 0.05);
			}
			
			.logout-button {
				justify-content: center;
				margin-top: 0.5rem;
				
				&:hover {
					transform: none;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.p-confirm-dialog.custom-logout {
		margin: 1rem !important;
		max-width: calc(100vw - 2rem) !important;
	}
	
	.p-confirm-dialog.custom-logout .p-dialog-header {
		padding: 1.5rem !important;
	}
	
	.p-confirm-dialog.custom-logout .p-dialog-title {
		font-size: 1.2rem !important;
	}
	
	.p-confirm-dialog.custom-logout .p-dialog-content {
		padding: 2rem 1.5rem !important;
	}
	
	.p-confirm-dialog.custom-logout .confirm-dialog-custom p {
		font-size: 1rem !important;
	}
	
	.p-confirm-dialog.custom-logout .confirm-dialog-footer {
		flex-direction: column !important;
		gap: 0.8rem !important;
	}
	
	.p-confirm-dialog.custom-logout .p-button {
		width: 100% !important;
	}
}

/* Animazioni */
@keyframes dialog-appear {
	0% {
		opacity: 0;
		transform: scale(0.8) translateY(-50px);
	}
	100% {
		opacity: 1;
		transform: scale(1) translateY(0);
	}
}

@keyframes logout-pulse {
	0%, 100% { 
		transform: scale(1); 
	}
	50% { 
		transform: scale(1.1); 
	}
}

/* Pulse Status Indicators */
.pulse-ok {
	background-color: #2bcb12;
	animation: 2s infinite pulse-anim;
}

.pulse-err {
	background-color: #fa2121;
	animation: 2s infinite pulse-anim;
}

@keyframes pulse-anim {
	0% { 
		box-shadow: currentColor 0 0 0 0; 
	}
	100% { 
		box-shadow: transparent 0 0 0 6px; 
	}
}

/* Accessibilità e Focus States */
@media (prefers-reduced-motion: reduce) {
	* {
		animation: none !important;
		transition: none !important;
	}
}

.logout-button:focus,
.p-button:focus {
	outline: 2px solid #4a90e2 !important;
	outline-offset: 2px !important;
}
</style>